export default {
  sidebar: {
    agentError: '無法從代理程式取得回應。',
    creditsExhausted:
      '此工作區的 Khorium Agent 使用額度已用完。請聯絡您的管理員以繼續使用。',
    notEntitled:
      '您在此工作區沒有 Khorium Agent 的有效席位或訂閱。請工作區管理員為您指派席位，或聯絡支援團隊。',
    updateSessionError: '無法更新工作階段',
    renameSessionError: '無法重新命名工作階段',
    pinSessionError: '無法釘選工作階段',
    loadHistoryError: '無法載入工作階段歷史記錄',
    loadTranscriptTimeout: '此對話載入時間過長。請重試，或開始新的聊天。',
    loadTranscriptTooLarge: '此對話太大，無法載入。請開始新的聊天以繼續。',
    resizeHandle: '調整聊天面板大小',
    untitled: '未命名',
    updatedPrefix: '更新於',
    newChat: '新聊天',
    newChatTooltip: '新聊天',
    showHistory: '顯示聊天記錄',
    hideHistory: '隱藏聊天記錄',
    showHistoryTooltip: '顯示聊天記錄',
    hideHistoryTooltip: '隱藏聊天記錄',
    restoringSession: '正在還原您的對話…',
    maximize: '進入全螢幕',
    minimize: '退出全螢幕',
    maximizeTooltip: '進入全螢幕',
    minimizeTooltip: '退出全螢幕',
    collapse: '收合聊天',
    collapseTooltip: '收合聊天',
  },
  attachment: {
    imagePreviewAlt: '圖片預覽',
    imagePreviewTitle: '圖片附件預覽',
    thumbAlt: '附件預覽',
    typeImage: '圖片',
    typeDocument: '文件',
    typeFile: '檔案',
    tileLabel: '{{type}}附件',
    chipLabel: '{{type}}附件：{{name}}',
    removeFile: '移除檔案',
    addAttachment: '附加 CAD 零件',
    addAttachmentTooltip: '附加 CAD 零件（{{types}}）',
    uploadFailed: '上傳失敗',
  },
  sessionList: {
    loadError: '無法載入工作階段',
    header: '聊天記錄',
    searchPlaceholder: '搜尋聊天…',
    loading: '正在載入聊天記錄…',
    emptyNoMatch: '沒有符合的聊天。',
    emptyNone: '尚無聊天記錄。',
    emptyNoAutoRetry: '尚無 AI 重試記錄。',
    scopeLabel: '工作階段類型',
    scopeChats: '聊天',
    scopeAutoRetry: 'AI 重試',
    pinned: '已釘選',
    recent: '最近',
    untitled: '未命名聊天',
    unpin: '取消釘選聊天',
    pin: '釘選聊天',
    unpinTooltip: '取消釘選聊天',
    pinTooltip: '釘選聊天',
    rename: '重新命名聊天',
    renameTooltip: '重新命名聊天',
  },
  thread: {
    helpful: '有幫助',
    unhelpful: '沒有幫助',
    welcomeTitle: '您好！',
    welcomeSubtitle: '今天我能為您做些什麼？',
    scrollToBottom: '捲動至底部',
    inputPlaceholder: '傳送訊息…',
    inputLabel: '訊息輸入',
    screenshotOn: '視埠螢幕截圖已開啟',
    screenshotOff: '視埠螢幕截圖已關閉',
    toggleScreenshot: '切換視埠螢幕截圖',
    approvalMode: '工具核准',
    approvalAuto: '自動核准',
    approvalAutoShort: '自動',
    approvalManual: '手動 — 先詢問',
    approvalManualShort: '手動',
    sendMessage: '傳送訊息',
    waitingForUpload: '正在等待 {{file}} 上傳完成',
    waitingForApproval: '請先回覆上方的確認',
    stopGenerating: '停止產生',
    queueMessage: '在此回覆後傳送',
    queuedHeading: '等待傳送',
    queueRemove: '從等待清單移除',
    connectionLostWaiting: '連線中斷。正在等待回覆完成。',
    connectionLost: '無法確認代理程式是否仍在執行。請重新整理以再次確認。',
    runWorking: '代理程式正在處理中。回覆完成後會顯示在這裡。',
    runAwaitingClient:
      '此工作需要在原本的瀏覽器中執行操作。重複執行前請先確認結果。',
    runFailed: '代理程式無法完成此工作。已儲存的進度顯示於上方。',
    runCancelled: '此工作已停止。已儲存的進度顯示於上方。',
    copy: '複製',
    refresh: '重新整理',
    refreshHeldForApproval: '請先回答上方的問題',
    more: '更多',
    exportMarkdown: '匯出為 Markdown',
    edit: '編輯',
    editCancel: '取消',
    editUpdate: '更新',
    branchPrevious: '上一個',
    branchNext: '下一個',
  },
  approval: {
    titleBackend: '要讓助理執行這項操作嗎？',
    subtitleBackend: '這會變更你已儲存的成果，或開始會產生費用的作業。',
    allowOnce: '允許一次',
    deny: '拒絕',
    working: '處理中…',
    cancelled: '操作已取消',
    approved: '操作已核准',
    skipped: '操作已略過',
    failed: '操作失敗',
    askedBecauseManual: '因為核准模式為「手動」，所以詢問您',
    handCalcSet: '新增或取代 {{count}} 項：',
    handCalcRemove: '移除 {{count}} 項：',
    handCalcNew: '新增',
    handCalcReplacesEngineer: '取代工程師的',
    handCalcReplacesAgent: '取代 AI 的',
    handCalcEngineers: '工程師的',
    handCalcAgents: 'AI 的',
    handCalcMore: '及其他 {{count}} 項',
  },
  toolCalls: {
    verbMeshSettings: '設定網格尺寸',
    verbBoundaryLayer: '設定邊界層',
    verbViewerSettings: '設定檢視器',
    verbDomainParams: '設定流場域',
    verbInspect: '讀取設定',
    verbPrepare: '準備網格',
    verbRun: '執行研究',
    verbSimopsDraft: '編輯 SimOps 設定',
    verbRetryPoint: '重試設計點',
    usedTool: '已使用工具',
    targetMeshSetup: '網格設定',
    targetViewer: '檢視器',
    targetDomain: '流場域',
    targetGuidance: 'Khorium 指引',
    valueOn: '開啟',
    valueOff: '關閉',
    noChange: '沒有任何變更',
    arguments: '引數',
    result: '結果',
    group_one: '{{count}} 次工具呼叫',
    group_other: '{{count}} 次工具呼叫',
    retry: '重試',
    skip: '略過',
    retryMessage: '重試 {{step}}',
    skipMessage: '略過 {{step}}',
    sentBack: '已退回給助理再試一次',
    openStudy: '在 SimOps 開啟研究',
    openDesignPoint: '在 SimOps 開啟設計點',
    openMesh: '在 MeshGen 開啟網格',
    openPage: '開啟頁面',
    openGeometry: '要在 MeshGen 開啟嗎？',
    openGeometryFailed: '無法開啟 MeshGen，請再試一次。',
  },
  reasoning: {
    inProgress: '思考中…',
    unfinished: '思考（未完成）',
    done: '思考',
  },
  plan: {
    summary: '計畫 {{done}}/{{total}}',
    summaryWithStep: '計畫 {{done}}/{{total}} · {{step}}',
  },
  linkedPages: {
    button: '連結的頁面',
    buttonTooltip: '連結的頁面',
    title: '此聊天中的連結',
    empty: '助理連結的頁面會顯示在這裡。',
    detail: {
      dp: 'DP',
      mesh: '網格',
    },
  },
} as const;
